import * as React from "react"
const SvgFire = props => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="currentColor"
    viewBox="0 0 24 24"
    {...props}
  >
    <path d="M12 22q-3.35 0-5.675-2.325T4 14q0-2.825 1.675-5.425t4.6-4.55q.55-.375 1.137-.037Q12 4.325 12 5v1.3q0 .85.588 1.425.587.575 1.437.575.425 0 .813-.187.387-.188.687-.538a.85.85 0 0 1 .513-.312.72.72 0 0 1 .587.137 7.94 7.94 0 0 1 2.475 2.875q.9 1.75.9 3.725 0 3.35-2.325 5.675T12 22m-6-8q0 1.3.525 2.462.525 1.164 1.5 2.038A1 1 0 0 1 8 18.275v-.225q0-.8.3-1.5t.875-1.275L12 12.5l2.825 2.775q.575.575.875 1.275t.3 1.5v.225q0 .1-.025.225a6.1 6.1 0 0 0 1.5-2.038Q18 15.301 18 14q0-1.249-.462-2.363A6.1 6.1 0 0 0 16.2 9.65q-.5.326-1.05.487a4 4 0 0 1-1.125.163q-1.55 0-2.687-1.025a3.9 3.9 0 0 1-1.313-2.525q-1.95 1.65-2.988 3.512Q6 12.125 6 14m6 1.3-1.425 1.4a2 2 0 0 0-.425.625q-.15.35-.15.725 0 .8.588 1.375Q11.175 20 12 20t1.412-.575T14 18.05q0-.4-.15-.738t-.425-.612z" />
  </svg>
)
export default SvgFire
